import React, { useMemo, useState } from "react";
import LockIcon from "@mui/icons-material/Lock";
import { styles } from "../styles";
import { Stack, Box, Tooltip } from "@mui/material";
import { ReactComponent as LinkWheelCardIcon } from "@assets/images/LinkWheelCardIcon.svg";
import { ReactComponent as ClonedIcon } from "@assets/images/clonedBlue.svg";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SensorsIcon from "@mui/icons-material/Sensors";
import WheelComponent from "../../../../WheelComponent";
import TextView from "../../../../TextView";
import {
  convertSnakeToCamel,
  transformedText,
} from "../../../../../utils/helpers";
import DefaultIyugaLogo from "@assets/images/iyuga.jpg";
import { Visibility } from "@mui/icons-material";

const WheelInfoCard = ({ selected = false, wheelData, onWheelClick }) => {
  const modifiedSegmentData = useMemo(() => {
    return wheelData?.wheel_segments?.map((s) => {
      const { nodes, ...rest } = s;
      // const { activity, category, ...settingsRest } = s.settings;
      return {
        ...rest,
        category: 1, // This will replace with actual category id
        // settings: convertSnakeToCamel(settingsRest),
        nodes: JSON.stringify(nodes),
      };
    });
  }, [wheelData]);

  const clonedWheelData = modifiedSegmentData?.map((segment) => ({
    ...segment,
    ...segment?.settings,
  }));

  const isPrivate = wheelData?.visibility === 2;
  const isLocked = wheelData?.is_locked;
  const isCloned = wheelData?.is_cloned;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: "8px",
        justifyContent: "space-between",
        width: "100%",
        borderRadius: "4px",
        border: `1px solid ${selected ? "#E2B8F1" : "#E1E1E1"}`,
        backgroundColor: selected ? "#F5EFF7" : "white",
        cursor: "pointer",

        "&:hover": {
          border: `1px solid ${selected ? "red" : "#123051"}`,
        },
      }}
      onClick={() => onWheelClick(wheelData)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={styles.wheelContainer}>
          <div
            style={{
              width: "6.71444rem",
            }}
          >
            <WheelComponent
              userData={{
                id: Math.random() * 10,
                url:
                  wheelData?.wheel_center_media?.url ||
                  wheelData?.wheel_image ||
                  DefaultIyugaLogo,
              }}
              maxSelectedArcs={0}
              arcThickness={-10}
              chartData={clonedWheelData}
              margin={25}
              containerDivStyle={{
                width: "100%",
                height: "100%",
                pointerEvents: "none",
              }}
              // containerDivStyle={{
              //   width: "110px",
              //   height: "110px",
              //   pointerEvents: "none",
              // }}
            ></WheelComponent>
          </div>
        </Box>

        <Stack>
          <TextView
            color={"#123051"}
            style={{
              fontSize: "12px",
              textTransform: "capitalize",
              fontWeight: "700",
            }}
          >
            {wheelData?.wheel_name
              ? transformedText(wheelData.wheel_name)
              : "Untitled Wheel"}
          </TextView>

          <TextView
            color={"#565556"}
            style={{ fontSize: "10px", textTransform: "capitalize" }}
          >
            {wheelData?.user_profile?.first_name
              ? `${wheelData.user_profile?.first_name} ${wheelData.user_profile?.last_name}`
              : "-"}
          </TextView>
        </Stack>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          flexShrink: 0,
        }}
      >
        {isPrivate && (
          <Tooltip placement="top" arrow title="Private">
            <VisibilityOffIcon sx={styles.iconStyles} />
          </Tooltip>
        )}

        {isLocked && (
          <Tooltip placement="top" arrow title="Locked">
            <LockIcon sx={{ ...styles.iconStyles, color: "#123051" }} />
          </Tooltip>
        )}

        {/* <LinkWheelCardIcon /> */}

        {isCloned && (
          <Tooltip placement="top" arrow title="Cloned">
            <ClonedIcon />
          </Tooltip>
        )}

        {/* {selected && (
          <SensorsIcon sx={{ ...styles.iconStyles, color: "#FF7A5C" }} />
        )} */}
      </Box>
    </Box>
  );
};

export default WheelInfoCard;
